// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__gF2zI","toggleWrap":"styles_toggleWrap__2XtiA","content":"styles_content__3jrtq","selectAreaCode":"styles_selectAreaCode__3xmd8"};